import moment from 'moment';

const dateFormat = {
    methods: {
        formatDate: (date) => {
            return moment(date).format("DD.MM.YYYY")
        },

        formatDateTime: (date) => {
            return moment(date).format("DD.MM.YYYY H:M:S")
        },
    }
}

export default dateFormat;

